const style = {
  wrapper: {},
  block: {
    width: `24px`,
    height: `24px`,
    margin: `2px`,
    background: `rgba(0, 0, 0, 0.3)`,
    color: `white`,
    textAlign: `center`,
    lineHeight: `26px`,
    fontSize: `16px`
  },
  facebook: {
    ':hover': {
      background: `#3b5997`
    }
  },
  twitter: {
    ':hover': {
      background: `#41b7d8`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Header/style/social.js